import React, {
  useEffect,
  useState
} from "react";

import "./App.css";

import Layout from "./layouts/Layout";
import AnonyLayout from "./layouts/AnonyLayout";
import { useSSE, notify } from "./services/sse";
import { menus, anonyMenus } from "./layouts/menus";
import { useDispatch, useSelector } from "react-redux";

import { LOGIN, LOGOUT } from "./services/actions";

import { useNavigate, useLocation } from "react-router-dom";
import { onMessage } from "firebase/messaging"
import { getToken } from "firebase/messaging";
import { messaging } from "./firebase";

import { subscribeUser, unsubscribeUser, checkSubscription, } from "./services/notifications";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const auth =
    useSelector(
      (state) =>
        state?.loginState?.auth
    );
  const baseURL = process.env.REACT_APP_URL;

  const { connected } = useSSE(
    auth?.id ? `${baseURL}stream/${auth?.id}/` : null,
    {
      onMessage: (data) => {
        console.log("message", data)
        if (data.event === "info") {
          notify("info", data?.title || "New notification", data?.message || "New notification");
        }

        if (data.event === "warning") {
          notify("warning", data?.title || "New notification", data?.message || "New notification");
        }
        if (data.event === "error") {
          notify("error", data?.title || "New notification", data?.message || "New notification");
        }
        if (data.event === "success") {
          notify("success", data?.title || "New notification", data?.message || "New notification");
        }

        if (data.event === "message") {
          notify("info", data?.title || "New notification", data?.message || "New notification");
        }
      },
      onOpen: () => {
        console.log("SSE OPEN");
      },
      onError: (event) => {
        console.log("SSE ERROR", event);
      },
      autoReconnect: true,
      reconnectDelay: 3000,
    }
  );

  const markAsRead = async (id) => {
    const response = await fetch(
      `${baseURL}notification/${id}/`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth.token}`,
        },
        body: JSON.stringify({
          is_read: true,
        }),
      }
    );

    const data = await response.json();
    console.log(data);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [subscribed,
    setSubscribed] =
    useState(false);

  // ============================================
  // CHECK SUBSCRIPTION
  // ============================================

  useEffect(() => {

    const init = async () => {
      const isSubscribed = checkSubscription();
      console.log("SUBSCRIBED:", isSubscribed);
      setSubscribed(isSubscribed);
    };

    init();
  }, []);





  // ============================================
  //   FOREGROUND FCM
  //     ============================================

  // useEffect(() => {
  //   console.log("Messaging instance", messaging);
  //   const unsubscribe =
  //     onMessage(
  //       messaging,
  //       (payload) => {

  //         console.log(
  //           "FOREGROUND MESSAGE:",
  //           payload
  //         );

  //         if (
  //           Notification.permission ===
  //           "granted"
  //         ) {

  //           new Notification(

  //             payload.notification.title,

  //             {
  //               body:
  //                 payload.notification.body,

  //               icon:
  //                 "/logo192.png"
  //             }
  //           );
  //         }
  //       }
  //     );

  //   return () => unsubscribe();

  // }, [dispatch]);



  // ============================================
  // LOGOUT
  // ============================================

  const onLogout = () => {
    dispatch({ type: `${LOGOUT}_AUTH`, payload: null });
    navigate("/");
  };

  // ============================================
  // SUBSCRIBE / UNSUBSCRIBE
  // ============================================

  const onSubscribe =
    async () => {

      if (!auth?.id) {
        alert(
          "Login required"
        );
        return;
      }

      let success = false;

      if (subscribed) {

        success =
          await unsubscribeUser(
            baseURL
          );

      } else {

        success =
          await subscribeUser(
            baseURL,
            auth.id
          );
      }

      if (success) {

        const current =
          checkSubscription();

        setSubscribed(
          current
        );
      }
    };



  return (
    <>

      <ScrollToTop />
      {auth?.token && (
        <Layout
          menus={menus}
          onLogout={onLogout}
          appName={
            <label
              style={{
                fontWeight: 800
              }}
            >
              AXIS-WORK
            </label>
          }
          ispushsidebar={true}
          onSubScribe={
            onSubscribe
          }
          isSubscribed={
            subscribed
          }
        />
      )
      }
      {
        !auth?.token && (

          <AnonyLayout
            menus={anonyMenus}
          />
        )
      }

    </>
  );
}

export default App;